import React from 'react';
import type { SkyMood } from '../../../domain/SkyMood';

// Pseudoaleatorio estable por índice: las gotas y ráfagas no saltan de
// lugar en cada render.
const rand = (i: number, salt: number) => {
  const x = Math.sin(i * 12.9898 + salt * 78.233) * 43758.5453;
  return x - Math.floor(x);
};

const range = (n: number) => Array.from({ length: n }, (_, i) => i);

// Efectos de clima sobre el paisaje, solo CSS: gotas si llueve, ráfagas si
// hay viento, resolana si hay sol, nubes que pasan, estrellas de noche.
// Con "reducir movimiento" del sistema quedan quietos (ver home.css).
const WeatherFx: React.FC<{ mood: SkyMood }> = ({ mood }) => {
  const drops = mood.rain === 'heavy' ? 55 : mood.rain === 'light' ? 26 : 0;
  const gusts = mood.wind === 'strong' ? 9 : mood.wind === 'breeze' ? 5 : 0;
  // Las gotas se inclinan con el viento.
  const slant = mood.wind === 'strong' ? 18 : mood.wind === 'breeze' ? 9 : 3;
  const clouds = mood.clouds === 2 ? 4 : mood.clouds === 1 ? 2 : 0;

  return (
    <div className="weather-fx" aria-hidden="true">
      {mood.sun !== 'none' && <div className={`fx-sun fx-sun-${mood.sun} phase-${mood.phase}`} />}

      {mood.stars &&
        range(22).map((i) => (
          <span
            key={`s${i}`}
            className="fx-star"
            style={{
              left: `${rand(i, 1) * 100}%`,
              top: `${rand(i, 2) * 42}%`,
              animationDelay: `${rand(i, 3) * 4}s`,
            }}
          />
        ))}

      {range(clouds).map((i) => (
        <span
          key={`c${i}`}
          className={`fx-cloud ${mood.phase === 'night' ? 'is-night' : ''}`}
          style={{
            top: `${6 + rand(i, 4) * 26}%`,
            width: `${150 + rand(i, 5) * 120}px`,
            animationDuration: `${(mood.wind === 'none' ? 90 : 50) + rand(i, 6) * 40}s`,
            animationDelay: `${-rand(i, 7) * 90}s`,
          }}
        />
      ))}

      {range(gusts).map((i) => (
        <span
          key={`w${i}`}
          className="fx-gust"
          style={{
            top: `${18 + rand(i, 8) * 70}%`,
            width: `${70 + rand(i, 9) * 90}px`,
            animationDuration: `${(mood.wind === 'strong' ? 1.8 : 3) + rand(i, 10) * 2}s`,
            animationDelay: `${rand(i, 11) * 4}s`,
          }}
        />
      ))}

      {range(drops).map((i) => (
        <span
          key={`r${i}`}
          className="fx-drop"
          style={
            {
              left: `${rand(i, 12) * 110 - 5}%`,
              animationDuration: `${0.65 + rand(i, 13) * 0.5}s`,
              animationDelay: `${-rand(i, 14) * 2}s`,
              opacity: 0.35 + rand(i, 15) * 0.4,
              '--fx-slant': `${-slant}deg`,
              '--fx-dx': `${Math.round(380 * Math.tan((slant * Math.PI) / 180))}px`,
            } as React.CSSProperties
          }
        />
      ))}
    </div>
  );
};

export default WeatherFx;
